
<template>
  <div>
    <div class="font-weight-semi-bold mb-4 text-info"><translate>You are already logged with account:</translate> {{ user.email }}, {{user.first_name}} {{user.last_name}}</div>

    <CButton @click="$emit('accept')" block color="primary" class="mb-2" v-translate>Accept</CButton>
    <CButton @click="logout" color="secondary" block v-translate>Change account</CButton>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'AcceptLogged',
  emits: ['accept'],
  computed: {
    ...mapGetters('login', [
      'user',
        'invitation'
    ]),
  },
  methods: {
    ...mapActions('login', [
      'logout'
    ]),
  }
}
</script>
